export default class IntegrationFieldApiModel {
  constructor(rawModel) {
    this.IntegrationCode = rawModel?.IntegrationCode || null
    this.DisplayName = rawModel?.DisplayName || null
    this.Fields = rawModel?.Fields?.map(x => new FieldApiModel(x)) || []
  }
}

class FieldApiModel {
  constructor(rawModel) {
    this.FieldCode = rawModel?.FieldCode || null
    this.DisplayName = rawModel?.DisplayName || null
    this.Datatype = rawModel?.Datatype || null
    this.Values = mapValues(rawModel)
  }
}

const mapValues = rawModel => {
  if (!rawModel?.Values) return []
  if (!rawModel?.Datatype) return rawModel.Values
  if (rawModel.Datatype === 'Boolean') return rawModel.Values.map(x => x === 'true')
  return rawModel.Values
}
